export const getPrimaryAdvertiserUser = (users) => {
  if (!Array.isArray(users)) {
    return null;
  }

  return (
    users.find((user) => user.role === "advertiser" && !user.isDeleted) || null
  );
};

export const getAdvertiserUserSubtitle = (users, searchMatchedEmail = null) => {
  const advertiserUser = getPrimaryAdvertiserUser(users);
  const email = searchMatchedEmail || advertiserUser?.email;

  if (advertiserUser?.name && email) {
    return `${advertiserUser.name}/${email}`;
  }

  return email || advertiserUser?.name || null;
};
